import { values } from './_helpers'

const _enum = {
  bottles: 0,
  bottlesSimple: 1,
  orders: 2
}

const staticFilterPage = { ..._enum, name: 'staticFilterPage', values: values(_enum) }

export {
  staticFilterPage
}
